import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FadeInSection from '@/components/base/FadeInSection';
import AgencyTrustSection from '@/pages/home/components/AgencyTrustSection';
import RightFitSection from '@/pages/home/components/RightFitSection';

export default function ForAgencies() {
  return (
    <main>
      <Navbar />
      <div className="pt-14">
        <FadeInSection>
          <AgencyTrustSection />
        </FadeInSection>
        <FadeInSection>
          <RightFitSection />
        </FadeInSection>
      </div>
      <Footer />
    </main>
  );
}